import { PushAdapterInterface } from "@citychallenge/core";

export class PushAdapter implements PushAdapterInterface {
  private handleURL?: (url: string) => void;

  public async serviceWillMount() {
    // TODO: Implement
  }

  public setUserId = (_userId: string) => {
    // TODO: Implement
  };

  /**
   * Every time the users nickname changed we want to sync to to onesignal
   * for personalized push notifications
   */
  public setNickname = (_nickname: string) => {
    // TODO: Implement
  };
}
